import {map as _map, range as _range} from "lodash-es";

// TODO: enable when rdg canary re-adds range selection support (unless they support copy by default)
// const defaultParsePaste = str => (
//   str.split(/\r\n|\n|\r/)
//     .map(row => row.split('\t'))
// );
//
// export function getSelectionBounds (args) {
//   return {
//     topLeft: {
//       rowIdx: args.topLeft.rowIdx,
//       colIdx: args.topLeft.idx,
//     },
//     botRight: {
//       rowIdx: args.bottomRight.rowIdx,
//       colIdx: args.bottomRight.idx,
//     },
//   };
// }
//
// export function handleCopy (e, selectionBoundsRef, columns, gridListRef) {
//   e.preventDefault();
//   const { topLeft, botRight } = selectionBoundsRef.current;
//
//   // Loop through each row
//   const text = _range(topLeft.rowIdx, botRight.rowIdx + 1).map(
//     // Loop through each column
//     rowIdx => columns.slice(topLeft.colIdx, botRight.colIdx + 1).map(
//       // Grab the row values and make a text string
//       col => gridListRef.current[rowIdx][col.key],
//     ).join('\t'),
//   ).join('\n');
//   e.clipboardData.setData('text/plain', text);
// }
//
// export function handlePaste (e, selectionBoundsRef) {
//   e.preventDefault();
//   const pasteData = defaultParsePaste(e.clipboardData.getData('text/plain'));
//
//   console.log('paste', pasteData);
//   // TODO: handle paste data.
//   // should parse like we parse csvs to get the values we want, then check against
//   // current rows for duplicates (update name, etc... if row exists) and add
//   // new rows for new people
// }

export function handleFilterChange(filter) {
  return filters => {
    const newFilters = { ...filters };
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    return newFilters;
  };
}

const suggestionStringMessagingMap = {
  addSuggestion: "suggests adding",
  deleteSuggestion: "suggests removing"
}

function getSuggestionString(name, membership, suggestor) {
  if (suggestor == null || typeof suggestor === "undefined") {
    return "";
  }
  const verb = suggestionStringMessagingMap[membership.status];
  if (!verb) {
    return "";
  }

  const owner = suggestor.firstName || suggestor.name.split(' ')[0];
  return owner + " " + verb;
}

export function sortRows(initialRows, sortColumn, sortDirection) {
  const comparer = (a, b) => {
    let aValue = a[sortColumn];
    let bValue = b[sortColumn];
    if (sortColumn === "ana" || sortColumn == "ynp") {
      aValue = a.membership[sortColumn];
      bValue = b.membership[sortColumn];
    } else if (sortColumn === "notes") {
      aValue = a.notes?.notes || "";
      bValue = b.notes?.notes || "";
    } else if (sortColumn === "suggestion") {
      aValue = getSuggestionString(a.name, a.membership, a.suggestor);
      bValue = getSuggestionString(b.name, b.membership, b.suggestor);
    }
    if (sortDirection === "ASC") {
      return aValue > bValue ? 1 : -1;
    } else if (sortDirection === "DESC") {
      return aValue < bValue ? 1 : -1;
    }
  };
  return sortDirection === "NONE" ? initialRows : [...initialRows].sort(comparer);
}
